import application from 'application/application';

import moment from 'moment';

application

	.directive('ngDateSameOrBefore', () => ({
		require: 'ngModel',
		scope: {
			ngDateSameOrBefore: '='
		},
		link(scope, element, attrs, controller) {

			var format = attrs.ngDateFormat || 'DD/MM/YYYY';

			controller.$validators.dateSameOrBefore = modelValue => {

				if (controller.$isEmpty(modelValue) || !scope.ngDateSameOrBefore)

					return true;

				return moment(modelValue, format, true).isSameOrBefore(moment(scope.ngDateSameOrBefore, format, true));

			};

		}
	}));
